/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

/**
      * - TYPE_UNSPECIFIED: TYPE_UNSPECIFIED indicates an inconsistent 2FA state
Could be an issue with Janus or another service that is providing Janus with data.
 - NO_2FA: NO_2FA indicates no 2FA is required
 - SMS: SMS indicates SMS-based 2FA
 - TOTP: TOTP indicates Time-based One-Time Password 2FA
 - FIDO: FIDO indicates FIDO-based 2FA
To be replaced by U2F
 - U2F: U2F indicates Universal 2nd Factor authentication
 - DEVICE_VERIFICATION: DEVICE_VERIFICATION indicates device-based verification
 - IDV: IDV indicates Identity Verification
 - RECOVERY_CODE: RECOVERY_CODE indicates recovery code based 2FA
 - PUSH: PUSH indicates push notification based 2FA
 - BYPASS: BYPASS indicates bypass authentication
 - BACKUP_CODE: BACKUP_CODE indicates backup code based authentication
 - EMAIL: EMAIL indicates email-based authentication
 - SECURITY_QUESTION: SECURITY_QUESTION indicates security question based authentication
 - PASSWORD: PASSWORD indicates password-based authentication
 - PASSKEY: PASSKEY indicates passkey-based authentication
 - DATA_LOCKER: DATA_LOCKER indicates data locker based authentication
 - OAUTH: OAUTH indicates OAuth-based authentication
 - OAUTH_GOOGLE: OAUTH_GOOGLE indicates Google OAuth authentication
 - OAUTH_APPLE: OAUTH_APPLE indicates Apple OAuth authentication
 - DISPLAY_NAME: DISPLAY_NAME indicates display name based authentication
 - OAUTH_OKTA: OAUTH_OKTA indicates Okta OAuth authentication
 - GUARDIAN: GUARDIAN indicates guardian-based authentication
 - SSO: SSO indicates SSO-based authentication
 - CONSENSUS: CONSENSUS indicates multi-party consensus approval authentication
 - BIOMETRIC: BIOMETRIC indicates biometric-based authentication (facial recognition + liveness detection)
      * @Example No example provided
      */
export enum CoinbaseJanusSecondfactorSecondFactorType {
  TYPE_UNSPECIFIED = 'TYPE_UNSPECIFIED',
  NO_2FA = 'NO_2FA',
  SMS = 'SMS',
  TOTP = 'TOTP',
  FIDO = 'FIDO',
  U2F = 'U2F',
  DEVICE_VERIFICATION = 'DEVICE_VERIFICATION',
  IDV = 'IDV',
  RECOVERY_CODE = 'RECOVERY_CODE',
  PUSH = 'PUSH',
  BYPASS = 'BYPASS',
  BACKUP_CODE = 'BACKUP_CODE',
  EMAIL = 'EMAIL',
  SECURITY_QUESTION = 'SECURITY_QUESTION',
  PASSWORD = 'PASSWORD',
  PASSKEY = 'PASSKEY',
  DATA_LOCKER = 'DATA_LOCKER',
  OAUTH = 'OAUTH',
  OAUTH_GOOGLE = 'OAUTH_GOOGLE',
  OAUTH_APPLE = 'OAUTH_APPLE',
  DISPLAY_NAME = 'DISPLAY_NAME',
  OAUTH_OKTA = 'OAUTH_OKTA',
  GUARDIAN = 'GUARDIAN',
  SSO = 'SSO',
  CONSENSUS = 'CONSENSUS',
  BIOMETRIC = 'BIOMETRIC',
}
export const getCoinbaseJanusSecondfactorSecondFactorTypeErrors = (
  value: unknown,
): { fieldName: string; error: string }[] => {
  if (process.env.NODE_ENV === 'production') return [];
  if (!Object.values(CoinbaseJanusSecondfactorSecondFactorType).includes(value as any)) {
    return [
      {
        fieldName: '',
        error: ` ${value} is not a valid CoinbaseJanusSecondfactorSecondFactorType.`,
      },
    ];
  } else {
    return [];
  }
};

const validateCoinbaseJanusSecondfactorSecondFactorType = (value: unknown) => {
  const errors = getCoinbaseJanusSecondfactorSecondFactorTypeErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: CoinbaseJanusSecondfactorSecondFactorType data does not match contract.`,
      errors,
    );
  }
};
